import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { finishErrorAlert } from 'redux/alert/alert-actions'
import { useAppSelector } from 'redux/hooks'

import { COMPONENT_EXTENDER } from 'extender'

const NavBannerLayout = COMPONENT_EXTENDER('components/layouts/NavBannerLayout')
const SignIn = COMPONENT_EXTENDER('components/core/Forms/SignInForm')

const SignInPage = () => {
    const dispatch = useDispatch()
    const { errorAlert } = useAppSelector(state => state.alert)

    useEffect(() => {
        if (errorAlert) {
            dispatch(finishErrorAlert())
        }
    }, [])

    return (
        <>
            <NavBannerLayout signPage="signin">
                <SignIn />
            </NavBannerLayout>
        </>
    )
}

export default SignInPage
